import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { Category } from '~Providers/BongLayout';
import { Textfit } from 'react-textfit';
import Icon from '~ComponentsImproved/Icon';
import Shape from '~Assets/icons/category-button-shape.svg';
import { getTextColor } from '~Utils/textColor';

const Wrapper = styled.div<{
  selected?: boolean;
  color: string;
}>`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: var(--lineHeightSmall);
  letter-spacing: var(--letterSpacing);
  color: var(--colorBlueGray1200);
  background: ${({ color }) => color};

  box-sizing: border-box;
  height: 48px;
  width: 80px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  padding: 8px;

  border-bottom: 1px solid var(--colorBlueGray1200);

  z-index: ${({ selected }) => (selected ? 3 : 1)};

  & > .category-pointer {
    height: 100%;
    width: 8px;
    position: absolute;
    right: -7px;
    display: ${({ selected }) => (selected ? 'block' : 'none')};
  }

  box-shadow: ${({ selected }) =>
    selected
      ? '0px 0px 8px rgb(0 0 0 / 16%), 0px 16px 24px rgb(0 0 0 / 16%), 0px 0px 32px rgb(0 0 0 / 12%)'
      : 'none'};
`;

const Title = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

interface Props {
  category: Category;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const areEqual = (prevProps: Props, nextProps: Props) => {
  return (
    prevProps.category.id === nextProps.category.id &&
    prevProps.isSelected === nextProps.isSelected
  );
};

const CategoryButton: FC<Props> = memo(({ category, isSelected, onSelect }) => {
  return (
    <Wrapper
      key={category.id}
      onClick={() => onSelect(category.id)}
      color={category.color}
      selected={isSelected}>
      <Title>
        <Textfit mode="multi" style={{ color: getTextColor(category.color) }}>
          {category.label}
        </Textfit>
      </Title>
      <Icon src={Shape} color={category.color} className="category-pointer" />
    </Wrapper>
  );
}, areEqual);

export default CategoryButton;
